import axios from 'axios'

export function downloadBuffer(buf: ArrayBuffer, file: { type: string; name: string }) {
  const objectUrl = URL.createObjectURL(new Blob([buf], { type: file.type }))
  const el = document.createElement('a')
  el.href = objectUrl
  el.download = file.name
  el.hidden = true
  el.click()
  el.remove()
}

export async function downloadFileFromLink(file: { type: string; name: string }, url: string) {
  // this is needed to rename the file stored in azure
  const response = await axios.get<ArrayBuffer>(url, { responseType: 'arraybuffer' })
  return downloadBuffer(response.data, file)
}

export function base64ToArrayBuffer(base64: string) {
  // Decode Base64 to a binary string
  const binaryString = atob(base64)

  // Create a Uint8Array from the binary string
  const length = binaryString.length
  const bytes = new Uint8Array(length)

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  return bytes.buffer
}
